import { TranslateFn } from '../../types'
import { dataHook, prefix } from '../../utils'
// @ts-ignore
import * as classes from './banner.css'
import { primaryButtonTemplate, secondaryButtonTemplate } from '../button'
import { textButtonTemplate } from '../text-button'
import { closeButtonTemplate } from '../close-button'

export const BANNER_HOOK = 'banner-root'
export const BANNER_SETTINGS_HOOK = 'banner-settings'
export const BANNER_ACCEPT_HOOK = 'banner-accept'
export const BANNER_DECLINE_ALL_HOOK = 'banner-decline-all'
export const BANNER_DECLINE_HOOK = 'banner-decline'
export const BANNER_TEXT_CONTAINER_HOOK = 'banner-text-container'
export const BANNER_TEXT_HOOK = 'banner-text'
export const BANNER_MOBILE_TEXT_HOOK = 'banner-text-mobile'

const renderListItems = (children: string[]) =>
  children
    .map((child) => `<li class="${classes.action}">${child}</li>`)
    .join('')

// prettier-ignore
export const createBannerTemplate = (
    t: TranslateFn,
    showClose: boolean = true,
    showDeclineAll: boolean = true
) => {
    // Note: This block decides the direction and UI of the buttons in the UL list view based on the props
    const acceptButton = showDeclineAll ? primaryButtonTemplate(t('CookieConsentBanner_AcceptButton_Label'), BANNER_ACCEPT_HOOK) : primaryButtonTemplate(t('CookieConsentBanner_AcceptButton_Label'), BANNER_ACCEPT_HOOK)
    const declineAllButton = showDeclineAll ? textButtonTemplate(t('CookieConsentBanner_DeclineAll_Label'), BANNER_DECLINE_ALL_HOOK, '', true) : ''
    const advancedButton = showDeclineAll ? secondaryButtonTemplate(t('CookieConsentBanner_AdvancedButton_Label'), BANNER_SETTINGS_HOOK, 'aria-haspopup="dialog"') : textButtonTemplate(t('CookieConsentBanner_AdvancedButton_Label'), BANNER_SETTINGS_HOOK, 'aria-haspopup="dialog"')
    const listItems = showDeclineAll ? [declineAllButton, advancedButton, acceptButton] : [advancedButton, acceptButton]

    return `<div
    ${dataHook(BANNER_HOOK)}
    class="${classes.banner}"
    role="region"
    aria-label="${t('CookieConsentBanner_AriaLabel')}"
    aria-describedby="${prefix(BANNER_TEXT_CONTAINER_HOOK)}"
>
    <p
        id="${prefix(BANNER_TEXT_CONTAINER_HOOK)}"
        class="${classes.content}"
        ${dataHook(BANNER_TEXT_CONTAINER_HOOK)}>
        <span ${dataHook(BANNER_TEXT_HOOK)} class="${classes.hiddenOnMobile}">${t('CookieConsentBanner_Text')}</span>
        <span ${dataHook(BANNER_MOBILE_TEXT_HOOK)} class="${classes.visibleOnMobile}">${t('CookieConsentBanner_Text_Mobile')}</span>
    </p>
    <ul class="${classes.actions} ${showDeclineAll ? classes.declineAll : ''}">
        ${renderListItems(listItems)}    
    </ul>
    ${showClose ? closeButtonTemplate(BANNER_DECLINE_HOOK, classes.close) : ''}
</div>`
}
